module.exports = "/_next/static/images/fea0cb28fb5798cdeefc3a445152345e-mulher-com-cachos-maravilhosos-segurando-cartao-xs@3x.jpg.webp";